import { Container } from "./styles";
import githubIcon from "../../assets/github.svg"
// import DownloadApp from '../../assets/download.webp'
import externalLink from "../../assets/external-link.svg"
import ScrollAnimation from "react-animate-on-scroll";


export function Project() {
  return (
    <Container id="experience">
      <h2>My Experience</h2>
      <div className="projects">

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
              Onyx Foundation  
              </div>
            </header>
            <div className="body">
              <h3>Senior Full-stack Developer(Web3)</h3>
              <p>✓ Spearheaded the development of decentralized applications (dApps) using React, Next.js, TypeScript, and Wagmi, enhancing scalability and performance.</p>
              <p>✓ Engineered efficient EVM smart contract interactions with Ethers.js and The Graph Protocol, reducing data-fetching latency by 30%.</p>
              <p>✓ Designed and standardized modular front-end components with Tailwind CSS and Storybook, ensuring UI consistency across the platform.</p>
              <p>✓ Integrated Layer 2 scaling solutions (Optimism, Arbitrum) in collaboration with blockchain engineers, cutting gas fees by 40%.</p>
              <p>✓ Guided junior developers in secure Web3 integration and front-end optimization through mentorship and comprehensive code reviews.</p>
              <p>✓ Managed agile sprints, ensuring smooth coordination between product, design, and engineering teams for efficient development and delivery.</p>
            </div>
          </div>
        </ScrollAnimation>


        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
              SubQuery  
              </div>
            </header>
            <div className="body">
              <h3>Senior Front-end and Web3 Developer</h3>
              <p>✓ Developed high-performance front-end interfaces with React, Redux, and Next.js, delivering seamless user experiences.</p>
              <p>✓ Optimized real-time blockchain data visualization by integrating The Graph Protocol for on-chain queries.</p>
              <p>✓ Enhanced DeFi functionality by implementing complex smart contract interactions using Ethers.js and Web3.js.</p>
              <p>✓ Designed and deployed a DeFi lending platform UI, enabling tokenized collateral management and real-time interest accrual tracking.</p>
              <p>✓ Elevated front-end efficiency by 35% through API call optimization and strategic use of React.memo and useCallback.</p>
              <p>✓ Directed front-end architecture strategies, improving maintainability while reducing technical debt.</p>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
              ePages  
              </div>
            </header>
            <div className="body">
              <h3>Front-end Web Developer</h3>
              <p>✓ Crafted responsive, cross-browser compatible UIs using HTML5, CSS3, JavaScript (ES6+), and Tailwind CSS.</p>
              <p>✓ Developed custom UI components, including modals, carousels, and accordions, cutting page load times by 20%.</p>
              <p>✓ Refined state management with Redux and optimized DOM interactions, boosting client-side performance.</p>
              <p>✓ Strengthened code reliability with Jest and React Testing Library, leading to a 25% reduction in production bugs.</p>
              <p>✓ Partnered with backend teams to seamlessly integrate RESTful APIs and GraphQL endpoints, enhancing data efficiency.</p>
              <p>✓ Designed and executed A/B testing strategies, increasing user engagement rates by 15%.</p>
            </div>
          </div>
        </ScrollAnimation>

        <ScrollAnimation animateIn="flipInX">
          <div className="project">
            <header>
              <div className="project-links">
              NexTech Solutions  
              </div>
            </header>
            <div className="body">
              <h3>Front-end Developer</h3>
              <p>✓ Contributed to the development and maintenance of web applications using JavaScript, HTML5, CSS3, and Bootstrap.</p>
              <p>✓ Revamped legacy applications by migrating them to React.js and TypeScript, improving maintainability and accelerating development cycles by 30%.</p>
              <p>✓ Enhanced UI interactivity and ensured WCAG compliance, improving accessibility and user engagement.</p>
              <p>✓ Optimized API call efficiency and reduced latency by 25% through close collaboration with senior developers.</p>
              <p>✓ Participated in Agile sprints, stand-up meetings, and code reviews, gaining valuable software development lifecycle experience.</p>
            </div>
          </div>
        </ScrollAnimation>
      </div>
    </Container>
  );
}

